export function generateSessionId(length = 16) {
  return [...Array(length / 2)]
    .map(() =>
      Math.floor(Math.random() * 256)
        .toString(16)
        .padStart(2, '0'),
    )
    .join('');
}

export const copyToClipboard = (text: string | null) => {
  if (text) {
    navigator.clipboard.writeText(text).catch((err) => {
      console.error('Failed to copy text: ', err);
    });
  }
};

export const convertReferencesToLinks = (
  text: string,
  links?: Array<{
    document: string;
    page: number;
    url: string;
  }>,
): string => {
  const referenceRegex = /\[Reference: ([^\]]+)\]/g;

  return text.replace(referenceRegex, (match, referenceText) => {
    if (links && links.length > 0) {
      const pageMatch = referenceText.match(/(.+)\s*[–-]\s*(?:Pagina|Page|Página|Seite|pagina|page|p\.?)\s*(\d+)/i);
      if (pageMatch) {
        const [, documentName, pageNumber] = pageMatch;
        const pageNum = parseInt(pageNumber, 10);

        const matchingLink = links.find((link) => {
          const docNameTrimmed = documentName.trim();
          if (link.document === docNameTrimmed && link.page === pageNum) {
            return true;
          }
          if (link.document.includes(docNameTrimmed) && link.page === pageNum) {
            return true;
          }
          if (docNameTrimmed.includes(link.document) && link.page === pageNum) {
            return true;
          }
          return false;
        });

        if (matchingLink) {
          return `[${referenceText}](${matchingLink.url})`;
        }
      }
    }

    return `[${referenceText}](#)`;
  });
};

export const getTextWidth = (text: string): number => {
  if (typeof document === 'undefined') return 0;

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return 0;

  context.font = '14px Avenir,Roboto,sans-serif, sans-serif';
  return context.measureText(text).width;
};

export const getAutocompleteDisplayText = (fullSuggestion: string, userInput: string): string => {
  if (fullSuggestion.startsWith(userInput)) {
    const suffix = fullSuggestion.slice(userInput.length);
    if (userInput.endsWith(' ') && suffix.startsWith(' ')) {
      return suffix.slice(1);
    }
    return suffix;
  }

  if (userInput.startsWith('/') && userInput.includes(' ')) {
    const userParts = userInput.split(' ').filter((part) => part.length > 0);
    const suggestionParts = fullSuggestion.split(' ').filter((part) => part.length > 0);

    if (userParts.length > 0 && suggestionParts.length > 0 && userParts[0] === suggestionParts[0]) {
      const remainingParts = suggestionParts.slice(userParts.length);
      if (remainingParts.length > 0 && userInput.endsWith(' ')) {
        return remainingParts.join(' ');
      }
      return '';
    }
  }

  let matchPosition = 0;
  for (let i = 0; i <= Math.min(fullSuggestion.length, userInput.length); i++) {
    if (fullSuggestion.slice(0, i) === userInput.slice(0, i)) {
      matchPosition = i;
    } else {
      break;
    }
  }

  const suffix = fullSuggestion.slice(matchPosition);
  if (userInput.endsWith(' ') && suffix.startsWith(' ')) {
    return suffix.slice(1);
  }
  return suffix;
};

export const formatTime = (seconds: number): string => {
  if (!isFinite(seconds) || isNaN(seconds)) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
};
